import { render, staticRenderFns } from "./NewEditCalendarioLetivoPage.vue?vue&type=template&id=ce591b30&scoped=true"
import script from "./NewEditCalendarioLetivoPage.vue?vue&type=script&lang=js"
export * from "./NewEditCalendarioLetivoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditCalendarioLetivoPage.vue?vue&type=style&index=0&id=ce591b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce591b30",
  null
  
)

export default component.exports